<template>
    <div class="app-burger" @click="onBurgerClick">
        <span class="app-burger-button-name">{{profileFullname}}</span>
        <img :src="profilePictureUrl"/>
        <i class="s-icon-arrow-down"/>
        <transition name="transition-down-scale">
            <ul class="el-dropdown-menu el-popper" v-if="showMenu">
                <li tabindex="-1" class="el-dropdown-menu__item main-side-bar-language-picker-item" @click="gotoHome">
                    {{$t('sidebar.menu.documents')}}
                </li>
                <li tabindex="-1" class="el-dropdown-menu__item main-side-bar-language-picker-item" @click="gotoSettings">
                    {{$t('sidebar.menu.settings')}}
                </li>
                <li tabindex="-1" class="el-dropdown-menu__item main-side-bar-language-picker-item" @click="logout">
                    {{$t('sidebar.menu.logout')}}
                </li>
                <div x-arrow="" class="popper__arrow" style="left: 8px;"></div>
            </ul>
        </transition>
    </div>
</template>

<i18n>
{
    "en": {
        "sidebar": {
            "menu": {
                "documents": "Documents",
                "settings": "Settings",
                "logout": "Logout"
            }
        }
    },
    "es": {
        "sidebar": {
            "menu": {
                "documents": "Documentos",
                "settings": "Ajustes",
                "logout": "Cierre de sesión"
            }
        }
    },
    "fr": {
        "sidebar": {
            "menu": {
                "documents": "Documents",
                "settings": "Paramètres",
                "logout": "Déconnexion"
            }
        }
    },
    "pt": {
        "sidebar": {
            "menu": {
                "documents": "Documentos",
                "settings": "Configurações",
                "logout": "Sair"
            }
        }
    },
    "de": {
        "sidebar": {
            "menu": {
                "documents": "Dokumente",
                "settings": "Einstellungen",
                "logout": "Abmeldung"
            }
        }
    },
    "nl": {
        "sidebar": {
            "menu": {
                "documents": "Documenten",
                "settings": "Instellingen",
                "logout": "Uitloggen"
            }
        }
    }
}
</i18n>

<script>
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'
import { userServices } from '@/modules/users/services/UserServices'

export default {
    components: {
    },
    data() {
        return {
            showMenu: false
        }
    },
    mounted()
    {
        document.addEventListener('mousedown', this.onMouseDown, true)
    },

    beforeDestroy()
    {
        document.removeEventListener('mousedown', this.onMouseDown, true)
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        profilePictureUrl() {
            return this.configStore.user.pictureUrl || require('@/assets/v3/img/icons/user.png')
        },
        profileFullname() {
            return this.configStore.user.firstName + ' ' + this.configStore.user.lastName
        },
        profileShortDescription() {
            return this.configStore.user.shortDescription
        },
        profileLinkedinUrl() {
            return 'https://www.linkedin.com/in/' + this.configStore.user.linkedinProfileUrl
        },
        isDev() {
            return globalVars.DEV
        }
    },
    methods: {
        onMouseDown(e) {
            // check if the event passes through our component element
            let el = e.target

            while (el) {
                // console.log('check', el, this.$el, el === this.$el)
                if (el === this.$el) return
                el = el.parentElement
            }

            // console.log('closing')

            this.showMenu = false
        },
        gotoHome() {
            this.$gotoRoute('home')
        },
        gotoSettings() {
            this.$gotoRoute('user-settings')
        },
        logout() {
            this.isLoading = true

            userServices.logUserOut().then((response) => {
                console.log('user logged out', response)
                this.$eventBusEmit('logout')
                sessionStorage.setItem('cv-user-id', '')
                sessionStorage.setItem('cv-user-language', '')
                sessionStorage.setItem('cv-user-token', '')
                localStorage.setItem('cv-user-id', '')
                localStorage.setItem('cv-user-language', '')
                localStorage.setItem('cv-user-token', '')
                window.open(this.$serverRootUrl, '_self')
            }).catch((error) => {
                console.log('error while logging user off', error)
                this.$showNotification(
                    error.errors,
                    'error'
                )
                this.isLoading = false
            })
        },
        onBurgerClick() {
            if (this.showMenu) {
                this.showMenu = false
            } else {
                this.showMenu = true
            }
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.app-burger
    position fixed
    top 16px
    right 16px + 78px + 16px
    display flex
    flex-direction row
    box-sizing border-box
    color #51B2E3
    align-items center
    gap 10px
    cursor pointer
    transition all 0.25s
    user-select none

    &:hover
        color alpha(#51B2E3, 0.6)

    img
        border-radius 5px
        box-shadow 0px 0.821258px 1.64252px rgba(0, 0, 0, 0.25)
        width 40px
        height 40px
        background-color #e5e5e5

    .app-burger-button-name
        font-size 16px
        font-weight 500

    i
        font-size 12px
        font-weight 500

    .el-popper
        transform-origin top
        top 48px
        width 100%

        li
            font-weight 500

</style>



// WEBPACK FOOTER //
// src/modules/app/components/AppBurger.vue